import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { actions as ThreadsActions } from 'data/threads'
import { selectors as ThreadsSelectors } from 'data/threads'
import { providesAddCommentToThread } from '../dataSync'

import CommentCreator from '../Comment/Creator'

class ThreadsReplier extends Component {
  static propTypes = {
    addCommentToThread: PropTypes.func.isRequired,
    threadId: PropTypes.string.isRequired,
  }
  componentDidMount() {
    if (this.editor) {
      this.editor.scrollIntoView({ block: 'end' })
    }
  }

  sendReply = (content, entities) => {
    const { threadId, addCommentToThread } = this.props
    addCommentToThread({
      comment: {
        threadId,
        content,
        entities,
      },
    })
    this.props.setThreadDraft({ key: this.props.threadId, content: '' })
  }

  onChange = content => {
    this.props.setThreadDraft({ key: this.props.threadId, content })
  }
  render() {
    return (
      <div ref={ref => (this.editor = ref)}>
        <CommentCreator
          onSubmit={this.sendReply}
          threadDraft={this.props.threadDraft}
          onChange={this.onChange}
          autoFocus
          placeholder={'Reply...'}
          replier
          threadSubscriberIds={this.props.threadSubscriberIds}
          sendStatus={this.props.createCommentStatus}
        />
      </div>
    )
  }
}

const mapDispatchToProps = {
  setThreadDraft: ThreadsActions.setThreadDraft,
}
const ThreadReplierConnected = compose(
  connect(
    (state, ownProps) => {
      const threadDraft = ThreadsSelectors.getThreadDraft(
        state,
        ownProps.threadId
      )
      return {
        threadDraft,
      }
    },
    mapDispatchToProps
  ),
  providesAddCommentToThread
)(ThreadsReplier)

export default ThreadReplierConnected
